<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-users-class" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{ session.title }}</div>
            <div class="meta"><i class="fas fa-user-tie fa-fw mr-2"></i>{{session.presenter}}</div>
            <div class="meta"><i class="far fa-list fa-fw mr-2"></i>{{session.slot}}</div>
            <div class="meta"><i class="far fa-clock fa-fw mr-2"></i>{{session.start_at | moment('MMM Do, YYYY h:mm A')}} - {{session.end_at | moment('MMM Do, YYYY h:mm A')}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">

                </span>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'RmcSessionTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            session: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
